<template>
    <el-dialog title="设置数据规则" :width="row.basicAssemblyId == '16' ? '60%':'40%'" append-to-body
               :close-on-click-modal="false" :visible.sync="visible">
        <el-form class="dataRule" size="small" :model="form" ref="form" label-width="140px" v-loading="loading"
                 @keyup.enter.native="doSubmit()" @submit.native.prevent>

            <el-form-item label="元数据别名：" v-if="row.basicAssemblyId == '16'">
                <el-input v-model="row.basicRename" disabled v-if="row.basicRename"></el-input>
                <el-input v-model="row.basicName" disabled v-else></el-input>
            </el-form-item>
            <el-form-item label="元数据组件类型：" v-else>
                <el-input v-model="row.metadataBasicAssemblyName" disabled></el-input>
            </el-form-item>
            <!--单行文本、多行文本-->
            <div v-if="row.basicAssemblyId == '1' || row.basicAssemblyId == '2'">
                <el-form-item label="文本限制：" prop="ruleMin">
                    <div class="flex_b_c">
                        <el-input-number class="w100i" v-model="form.ruleMin" :min="1" :max="form.ruleMax-1"
                                         placeholder="最小字符数"></el-input-number>
                        <span class="p_l1 p_r1">至</span>
                        <el-input-number class="w100i" v-model="form.ruleMax" :min="form.ruleMin+1"
                                         :max="row.basicAssemblyId == '1' ? 200 : 2000"
                                         placeholder="最大字符数" @change="changeRuleMax"></el-input-number>
                    </div>
                </el-form-item>
                <el-form-item label="数值唯一：" prop="numericUnique">
                    <el-radio-group v-model="form.numericUnique">
                        <el-radio label="0">是</el-radio>
                        <el-radio label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="数据规则：" prop="ruleMode">
                    <el-select v-model="form.ruleMode" class="w100i" placeholder="请选择数据规则" clearable
                               @change="changeRuleMode">
                        <el-option label="固定默认值" value="0"></el-option>
                        <el-option label="字段叠加" value="1"></el-option>
                        <el-option label="附件参数" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="默认值：" prop="ruleDefaultValue" v-show="form.ruleMode == '0'">
                    <el-input v-model.trim="form.ruleDefaultValue" placeholder="请输入默认值" clearable
                              :maxlength="form.ruleMax"></el-input>
                </el-form-item>
                <el-form-item label="选择字段：" prop="ruleDetailList" v-show="form.ruleMode == '1'">
                    <el-button size="small" type="primary" @click="add()" :disabled="form.ruleDetailList.length == 6">
                        添加字段
                    </el-button>
                    <div class="fieldBox" v-if="form.ruleDetailList.length">
                        <draggable v-model="form.ruleDetailList" element="tbody" class="block"
                                   :options="{animation: 150, handle: '.allowDrag'}">
                            <el-row v-for="(item, index) in form.ruleDetailList" :key="index">
                                <el-col :span="4">{{index+1}}</el-col>
                                <el-col :span="14">{{item.basicRename}}</el-col>
                                <el-col :span="6" class="text_right">
                                    <el-link icon="el-icon-rank" class="allowDrag m_l1" :underline="false"></el-link>
                                    <el-link :underline="false" type="primary" class="el-icon-delete m_l1"
                                             @click="del(index)"></el-link>
                                </el-col>
                            </el-row>
                        </draggable>
                    </div>
                </el-form-item>
                <el-form-item :label="'固定值'+(i+1)+'：'" prop="ruleStep"
                              v-for="(v, i) in form.ruleDetailList.filter(c=>c.basicDataDetailId==1)" :key="i">
                    <el-input v-model="v.fieldOverlayFixed" placeholder="请输入" clearable maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="开始序号：" prop="ruleStartNumber"
                              v-if="form.ruleDetailList.filter(v=>v.basicDataDetailId==0).length"
                              :rules="[{required: true, message: '开始序号不能为空', trigger: 'blur'}]">
                    <el-input v-model="form.ruleStartNumber" placeholder="请输入开始序号" clearable maxlength="99999"
                              @input="(v)=>(form.ruleStartNumber=v.replace(/[^\d-]/g,''))"></el-input>
                </el-form-item>
                <el-form-item label="步长：" prop="ruleStep"
                              v-if="form.ruleDetailList.filter(v=>v.basicDataDetailId==0).length"
                              :rules="[{required: true, message: '步长不能为空', trigger: 'blur'}]">
                    <el-input v-model="form.ruleStep" placeholder="请输入步长" clearable maxlength="99999"
                              @input="(v)=>(form.ruleStep=v.replace(/[^\d-]/g,''))"></el-input>
                </el-form-item>
                <el-form-item label="字段分割符：" prop="ruleSplit" v-if="form.ruleMode == '1'">
                    <el-input v-model="form.ruleSplit" placeholder="请输入分割符（- * / | 空格）" clearable maxlength="1"
                              @input="(v)=>(form.ruleSplit=v.replace(/[^-*/|\s]/g,''))"></el-input>
                </el-form-item>
                <el-form-item label="关联元数据：" prop="ruleAssociationBasicId" v-if="form.ruleMode == '2'">
                    <el-select v-model="form.ruleAssociationBasicId" class="w100i" placeholder="请选择关联元数据" filterable
                               clearable @change="changeRuleAssociation">
                        <el-option :label="item.basicRename" :value="item.id"
                                   v-for="(item, index) in ruleAssociationBasicIdOpt" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="参数值：" prop="ruleAssociationValue" v-if="form.ruleMode == '2'">
                    <el-select v-model="form.ruleAssociationValue" class="w100i" placeholder="请选择参数值" clearable
                               @focus="selRuleAssociationValue">
                        <el-option
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                v-for="item in ruleAssociationValueOpt">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--时间、日期组件-->
            <div v-if="row.basicAssemblyId == '8' || row.basicAssemblyId == '9'">
                <el-form-item :label="basicAssemblyName + '格式：'" prop="ruleDateFormat">
                    <el-select v-model="form.ruleDateFormat" class="w100i" placeholder="请选择格式" clearable
                               v-if="row.basicAssemblyId == '9'">
                        <el-option label="YYYY-MM-DD hh:mm:ss" value="yyyy-MM-dd HH:mm:ss"></el-option>
                        <el-option label="YYYY-MM-DD" value="yyyy-MM-dd"></el-option>
                        <el-option label="YYYY/MM/DD" value="yyyy/MM/dd"></el-option>
                        <el-option label="YYYY-MM" value="yyyy-MM"></el-option>
                        <el-option label="YYYY" value="yyyy"></el-option>
                    </el-select>
                    <el-select v-model="form.ruleDateFormat" class="w100i" placeholder="请选择格式" clearable v-else>
                        <el-option label="hh:mm:ss" value="HH:mm:ss"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="basicAssemblyName + '区间限制：'" prop="ruleDateType">
                    <el-select v-model="form.ruleDateType" class="w100i" placeholder="请选择" clearable
                               @change="changeRuleDateType">
                        <el-option :label="'不得大于当前' + basicAssemblyName" value="0"></el-option>
                        <el-option :label="'不得小于当前' + basicAssemblyName" value="1"></el-option>
                        <el-option :label="basicAssemblyName + '区间手动设置'" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="basicAssemblyName + '区间选择：'" prop="ruleDateStart"
                              v-if="form.ruleDateType == '2' && form.ruleDateFormat">
                    <div v-if="row.basicAssemblyId == '9'">
                        <el-date-picker
                                v-model="startDate" class="w100i"
                                type="monthrange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                                :format="form.ruleDateFormat" v-if="form.ruleDateFormat == 'yyyy-MM'">
                        </el-date-picker>
                        <div class="flex_b_c" v-else-if="form.ruleDateFormat == 'yyyy'">
                            <el-date-picker
                                    v-model="startDate[0]"
                                    type="year"
                                    placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
                                    :format="form.ruleDateFormat">
                            </el-date-picker>
                            <span class="m_r1 m_l1">至</span>
                            <el-date-picker
                                    v-model="startDate[1]"
                                    type="year"
                                    placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"
                                    :format="form.ruleDateFormat">
                            </el-date-picker>
                        </div>
                        <el-date-picker v-model="startDate" class="w100i"
                                        :type="form.ruleDateFormat == 'yyyy-MM-dd HH:mm:ss'?'datetimerange':'daterange'"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                                        :format="form.ruleDateFormat" v-else>
                        </el-date-picker>
                    </div>
                    <el-time-picker class="w100i"
                                    is-range
                                    v-model="startDate"
                                    range-separator="至"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间"
                                    placeholder="选择时间范围" value-format="yyyy-MM-dd HH:mm:ss"
                                    :format="form.ruleDateFormat" v-else>
                    </el-time-picker>
                </el-form-item>
            </div>
            <!--数字组件-->
            <div v-if="row.basicAssemblyId == '12'">
                <el-form-item label="保留小数点：" prop="ruleDecimal">
                    <el-input-number class="w100i" v-model="form.ruleDecimal" :min="0" :max="10"
                                     placeholder="请输入保留小数点位数"></el-input-number>
                </el-form-item>
                <el-form-item label="数字限制：" prop="ruleMin">
                    <div class="flex_b_c">
                        <el-input v-model.trim="form.ruleMin" placeholder="最小数值" clearable maxlength="8"
                                  @input="(v)=>(form.ruleMin=v.replace(/[^\d-]/g,''))"
                                  @blur="numChange(form.ruleMin, 'ruleMin')"></el-input>
                        <span class="p_l1 p_r1">至</span>
                        <el-input v-model.trim="form.ruleMax" placeholder="最大数值" clearable maxlength="8"
                                  @input="(v)=>(form.ruleMax=v.replace(/[^\d-]/g,''))"
                                  @blur="numChange(form.ruleMax, 'ruleMax')"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="默认值：" prop="ruleDefaultValue">
                    <el-input v-model.trim="form.ruleDefaultValue" placeholder="请输入默认值" clearable
                              maxlength="20" @input="(v)=>(form.ruleDefaultValue=v.replace(/[^\d-.]/g,''))"
                              @blur="changeRuleDefaultValue()"></el-input>
                </el-form-item>
            </div>
            <!--开关-->
            <div v-if="row.basicAssemblyId == '10'">
                <el-form-item label="默认值：" prop="ruleDefaultValue">
                    <el-select v-model="form.ruleDefaultValue" class="w100i" placeholder="请选择" clearable>
                        <el-option label="开" value="0"></el-option>
                        <el-option label="关" value="1"></el-option>
                    </el-select>
                </el-form-item>
            </div>
            <!--附件、图片、视频、音频-->
            <div v-if="row.basicAssemblyId == '13' || row.basicAssemblyId == '14' || row.basicAssemblyId == '15' || row.basicAssemblyId == '17'">
                <el-form-item label="文件格式：" prop="ruleFormatRestrictions"
                              :rules="[{required: true, message: '文件格式不能为空', trigger: 'blur'}]">
                    <el-input v-model.trim="form.ruleFormatRestrictions" placeholder="请输入可上传的格式（多种格式用英文“;”隔开；不区分大小写）"
                              clearable
                              maxlength="500"
                              @input="(v)=>(form.ruleFormatRestrictions=v.replace(/[^\w;]/g,''))"></el-input>
                </el-form-item>
                <el-form-item label="附件大小：" prop="ruleMax"
                              :rules="[{required: true, message: '附件大小不能为空', trigger: 'blur'}]">
                    <div class="flex_l_c">
                        <el-input v-model.trim="form.ruleMax" placeholder="最大文件" clearable
                                  maxlength="7" @input="(v)=>(form.ruleMax=v.replace(/[^\d]/g,''))"
                                  @blur="attachmentSize()"></el-input>
                        <el-select v-model="form.ruleMaxFormat" placeholder="请选择" @change="attachmentSize">
                            <el-option
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    v-for="item in $dictUtils.getDictList('ruleMaxFormat')">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="文件数量：" prop="ruleNumberMax"
                              :rules="[{required: true, message: '文件数量不能为空', trigger: 'blur'}]">
                    <el-input v-model.trim="form.ruleNumberMax" placeholder="最大数量" clearable
                              maxlength="3" @input="(v)=>(form.ruleNumberMax=v.replace(/[^\d]/g,''))"
                              @blur="fileNum()"></el-input>
                </el-form-item>
            </div>
            <!--数据关联-->
            <div v-if="row.basicAssemblyId == '16'">
                <el-form-item label="数据来源：" prop="associationBasicDataId">
                    <el-select class="w100i" v-model="form.associationBasicDataId" placeholder="请选择数据来源" filterable
                               clearable @change="getTemplate">
                        <el-option
                                :key="item.id"
                                :label="item.tableName"
                                :value="item.id" :disabled="item.disabled == '1'"
                                v-for="item in associationBasicDataIdOpt">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div>
                    <el-form-item class="w100i conditionBox" :label="item.basicDataName+ '：'"
                                  v-for="(item, index) in form.metadataBasicDataRuleLoadsetting" :key="index">
                        <div v-for="(itemC, indexC) in item.metadataBasicDataAssociationDetailList" :key="indexC">
                            <el-form-item class="conditionApproach"
                                          :prop="`metadataBasicDataRuleLoadsetting[${index}].metadataBasicDataAssociationDetailList[${indexC}].conditionApproach`"
                                          label-width="0px">
                                <el-select v-model="itemC.conditionApproach" placeholder="请选择">
                                    <el-option v-for="(e, i) in  $dictUtils.getDictList('conditionApproach')" :key="i"
                                               :label="e.label"
                                               :value="e.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                    :prop="`metadataBasicDataRuleLoadsetting[${index}].metadataBasicDataAssociationDetailList[${indexC}].basicDataDetailId`"
                                    :rules="[{required: true, message: '元数据不能为空', trigger: 'change'}]"
                                    label-width="10px">
                                <el-select v-model="itemC.basicDataDetailId" placeholder="请选择" filterable
                                           @change="archivesChange(item, itemC)">
                                    <el-option v-for="c in item.children" :key="c.id" :label="c.basicRename"
                                               :value="c.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                    :prop="`metadataBasicDataRuleLoadsetting[${index}].metadataBasicDataAssociationDetailList[${indexC}].basicCondition`"
                                    :rules="[{required: true, message: '条件不能为空', trigger: 'change'}]"
                                    label-width="10px">
                                <el-select v-model="itemC.basicCondition" placeholder="请选择"
                                           @change="conditionChange(itemC)">
                                    <el-option
                                            :key="v.value"
                                            :label="v.label"
                                            :value="v.value"
                                            v-for="v in getMethodCode(itemC)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                    :prop="`metadataBasicDataRuleLoadsetting[${index}].metadataBasicDataAssociationDetailList[${indexC}].conditionValue`"
                                    :rules="[{required: true, message: '条件值不能为空', trigger: 'change'}, validatorDataRule(itemC)]"
                                    v-if="itemC.basicCondition && itemC.basicCondition != '=null' && itemC.basicCondition != '!=null'"
                                    label-width="10px">
                                <!--单行文本-->
                                <el-input v-model.trim="itemC.conditionValue" placeholder="请输入"
                                          :maxlength="itemC.metadataBasicDataRuleVo && itemC.metadataBasicDataRuleVo.ruleMax ? (itemC.metadataBasicDataRuleVo.ruleMax)*1 : 200"
                                          clearable
                                          v-if="itemC.basicAssemblyId == '1'"></el-input>
                                <!--多行文本-->
                                <el-input v-model.trim="itemC.conditionValue" placeholder="请输入"
                                          :maxlength="itemC.metadataBasicDataRuleVo && itemC.metadataBasicDataRuleVo.ruleMax ? (itemC.metadataBasicDataRuleVo.ruleMax)*1 : 2000"
                                          type="textarea"
                                          :rows="1" v-if="itemC.basicAssemblyId == '2'"></el-input>
                                <!--数字-->
                                <el-input v-model.trim="itemC.conditionValue" placeholder="请输入" clearable maxlength="19"
                                          @input="(v)=>(itemC.conditionValue=v.replace(/[^\d-.]/g,''))"
                                          v-if="itemC.basicAssemblyId == '12'"></el-input>
                                <!--下拉单选、单选框组、下拉多选、多选框组-->
                                <el-select class="w100i" v-model="itemC.conditionValue"
                                           :multiple="itemC.basicAssemblyId == '6' || itemC.basicAssemblyId == '7'"
                                           placeholder="请选择" clearable
                                           v-if="itemC.basicAssemblyId == '4' || itemC.basicAssemblyId == '5' || itemC.basicAssemblyId == '6' || itemC.basicAssemblyId == '7' || itemC.basicAssemblyId == '10'">
                                    <el-option v-for="(v,i) in itemC.basicRangeList" :key="i"
                                               :label="v.basicRange"
                                               :value="v.metadataRangeId"></el-option>
                                </el-select>
                                <!--时间-->
                                <el-time-picker class="w100i" v-model="itemC.conditionValue" placeholder="请选择"
                                                value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                                clearable v-if="itemC.basicAssemblyId == '8'"></el-time-picker>
                                <!--日期-->
                                <el-date-picker class="w100i"
                                                v-model="itemC.conditionValue" value-format="yyyy-MM-dd HH:mm:ss"
                                                :format="itemC.metadataBasicDataRuleVo ? itemC.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                                :type="setDatePickerType(itemC)"
                                                clearable placeholder="请选择"
                                                v-if="itemC.basicAssemblyId == '9'"></el-date-picker>
                            </el-form-item>
                            <el-link class="m_l1" icon="el-icon-delete" type="danger" :underline="false"
                                     @click="delCondition(item, indexC)"></el-link>
                        </div>
                        <el-button type="text" class="addCondition" @click="addCondition(item)">
                            + 设置数据条件
                        </el-button>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" :disabled="loading" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
        <el-dialog title="选择字段" width="20%" append-to-body :close-on-click-modal="false" :visible.sync="fieldVisible">
            <el-input v-model="filterText" placeholder="输入关键字进行过滤" size="small" clearable maxlength="50"></el-input>
            <div class="fieldBox" v-loading="fieldLoading">
                <div class="text_center p_all1" v-show="!fieldList.length">暂无相关数据</div>
                <el-row v-for="(item, index) in fieldList" :key="index">
                    <el-col :span="4">{{index+1}}</el-col>
                    <el-col :span="16">{{item.basicRename}}</el-col>
                    <el-col :span="4">
                        <el-link class="fontSize12" :underline="false" type="primary"
                                 :disabled="form.ruleDetailList.filter(v => v.basicDataDetailId == item.id).length > 0 && item.id != 1"
                                 @click="choose(item)">选择
                        </el-link>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
    import draggable from "vuedraggable";
    import SelectTree from '@/components/treeSelect/treeSelect.vue'

    export default {
        components: {SelectTree, draggable},
        data() {
            return {
                visible: false,
                loading: false,
                method: '',
                row: {},
                basicAssemblyName: '',
                form: {
                    basicDataDetailId: '',
                    basicDataId: '',
                    id: '',
                    numericUnique: '0',
                    ruleMin: null,
                    ruleMax: null,
                    ruleMode: '',
                    ruleDefaultValue: '',
                    ruleDetailList: [],
                    ruleStartNumber: '',
                    ruleStep: '',
                    ruleSplit: '',
                    ruleAssociationBasicId: '',
                    ruleAssociationValue: '',
                    ruleDateFormat: 'yyyy-MM-dd',
                    ruleDateType: '',
                    ruleDateStart: '',
                    ruleDateEnd: '',
                    ruleDecimal: '0',
                    ruleFormatRestrictions: '',
                    ruleMaxFormat: 'MB',
                    ruleNumberMax: '',
                    associationBasicDataId: '', // 数据来源
                    metadataBasicDataRuleLoadsetting: [], // 数据来源-模板
                },
                startDate: [],
                ruleAssociationValueOpt: [],
                ruleAssociationBasicIdOpt: [],
                associationBasicDataIdOpt: [], // 数据来源
                // 选择字段
                fieldVisible: false,
                fieldLoading: false,
                fieldList: [],
                allFieldList: [],
                filterText: '',
                resetFlag: false,  // 关联数据选择数据来源重置相关数据的标识
            }
        },
        watch: {
            filterText(val) {
                this.fieldList = this.allFieldList.filter(item => item.basicRename.includes(val))
            }
        },
        methods: {
            init(row) {
                this.row = row
                this.startDate = []
                this.form.id = ''
                this.form = this.recover(this.form, this.form)
                this.form.metadataBasicDataRuleLoadsetting = []
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.resetFields();
                    this.form.basicDataDetailId = row.id
                    this.form.basicDataId = row.basicDataId
                    // 单行文本、多行文本
                    if (this.row.basicAssemblyId == '1' || this.row.basicAssemblyId == '2') {
                        this.form.ruleMin = 1
                        this.getFilesByBasicDataId()
                    }
                    if (this.row.basicAssemblyId == '1') {
                        this.form.ruleMax = 200
                    }
                    if (this.row.basicAssemblyId == '2') {
                        this.form.ruleMax = 2000
                    }
                    if (this.row.basicAssemblyId == '8') {
                        this.basicAssemblyName = '时间'
                        this.$set(this.form, 'ruleDateFormat', 'HH:mm:ss')
                        this.startDate = ['', '']
                    }
                    if (this.row.basicAssemblyId == '9') {
                        this.basicAssemblyName = '日期'
                        this.$set(this.form, 'ruleDateFormat', 'yyyy-MM-dd')
                    }
                    // 数据关联
                    if (this.row.basicAssemblyId == '16') {
                        this.getAssociationBasicDataId()
                    }
                    // 开关
                    if (this.row.basicAssemblyId == '10') {
                        this.$set(this.form, 'ruleDefaultValue', '0')
                    }
                    this.getInfo()
                })
            },
            // 查询详情信息
            getInfo() {
                this.loading = true
                this.$axios(this.api.metadata.getByBasicDataDetailId, {
                    basicDataDetailId: this.row.id,
                    basicDataId: this.row.basicDataId
                }).then(res => {
                    if (res.status) {
                        if (res.data) {
                            this.method = 'edit'
                            this.form = this.recover(this.form, res.data);
                            // 单行文本、多行文本 字段叠加
                            if (this.form.ruleMode == '1') {
                                let num = 0
                                this.form.ruleDetailList.map(item => {
                                    if (item.renumber == '0') {
                                        this.$set(item, 'basicDataDetailId', '0')
                                        this.$set(item, 'basicRename', '序号')
                                    }
                                    if (item.refixed == '0') {
                                        num++
                                        this.$set(item, 'basicDataDetailId', '1')
                                        this.$set(item, 'basicRename', '固定值' + num)
                                    }
                                    if (item.redate == '0') {
                                        this.$set(item, 'basicDataDetailId', '2')
                                        this.$set(item, 'basicRename', '当前日期')
                                    }
                                })
                            }
                            // 日期、时间组件 日期区间手动设置
                            if (this.form.ruleDateType == '2' && this.form.ruleDateStart && this.form.ruleDateEnd) {
                                this.startDate = [this.form.ruleDateStart, this.form.ruleDateEnd]
                            }
                            // 数据关联
                            if (this.row.basicAssemblyId == '16') {
                                this.getTemplate(1)
                            } else {
                                this.loading = false
                            }
                        } else {
                            this.method = 'add'
                            this.loading = false
                        }
                    } else {
                        this.$message.error('查询失败');
                        this.loading = false
                    }
                })
            },
            // 获取关联元数据
            getFilesByBasicDataId() {
                this.$axios(this.api.metadata.selectFilesByBasicDataId, {basicDataId: this.row.basicDataId}).then(data => {
                    if (data.status) {
                        this.ruleAssociationBasicIdOpt = data.data
                        this.changeRuleAssociation(this.form.ruleAssociationBasicId)
                    }
                })
            },
            // 查询模板下的所有元数据
            getAllByBasicDataId() {
                this.allFieldList = []
                this.fieldList = []
                this.$axios(this.api.metadata.selectAllByBasicDataId, {basicDataId: this.row.basicDataId}).then(data => {
                    if (data.status) {
                        this.allFieldList = [
                            {
                                id: '0',
                                basicRename: '序号'
                            },
                            {
                                id: '1',
                                basicRename: '固定值'
                            },
                            {
                                id: '2',
                                basicRename: '当前日期'
                            }
                        ]
                        data.data.map(item => {
                            if (item.associationBasicId != this.row.associationBasicId && (item.basicAssemblyId == '1' || item.basicAssemblyId == '8' || item.basicAssemblyId == '9' || item.basicAssemblyId == '12')) {
                                this.allFieldList.push(item)
                            }
                        })
                        this.fieldList = this.allFieldList
                    }
                    this.fieldLoading = false
                })
            },
            // 获取数据来源
            getAssociationBasicDataId() {
                this.$axios(this.api.metadata.metadatatableconfigList, {
                    current: 1,
                    size: 99999999
                }, 'post').then(data => {
                    if (data.status) {
                        this.associationBasicDataIdOpt = data.data.records
                        this.form = this.recover(this.form, this.form);
                    }
                })
            },
            // 添加字段
            add() {
                this.getAllByBasicDataId()
                this.filterText = ''
                this.fieldVisible = true
                this.fieldLoading = true
            },
            // 删除字段
            del(index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.form.ruleDetailList.splice(index, 1);
                })
            },
            // 选择
            choose(item) {
                this.fieldVisible = false
                let refixedDate = this.form.ruleDetailList.filter(v => {
                    return v.basicDataDetailId == '1'
                }).length + 1
                this.form.ruleDetailList.push({
                    basicDataDetailId: item.id,
                    basicRename: item.id == 1 ? item.basicRename + refixedDate : item.basicRename,
                    renumber: item.id == 0 ? '0' : '',
                    refixed: item.id == 1 ? '0' : '',
                    redate: item.id == 2 ? '0' : '',
                    fieldOverlayFixed: '',
                    sort: this.form.ruleDetailList.length + 1
                })
            },
            // 文本限制
            numChange(value, field) {
                let {ruleMin, ruleMax} = this.form
                if (value && !/^\+?[1-9][0-9]*$/.test(value) && this.row.basicAssemblyId == '1' || value && !/^\+?[1-9][0-9]*$/.test(value) && this.row.basicAssemblyId == '2') {
                    this.$message.warning('请输入正确的数值')
                    this.$set(this.form, field, '')
                    return
                }
                if (value && !/^(\-|\+)?\d+(\d+)?$/.test(value) && this.row.basicAssemblyId == '12') {
                    this.$message.warning('请输入正确的数值')
                    this.$set(this.form, field, '')
                    return
                }
                if (value && field == 'ruleMax') {
                    if (ruleMin && value <= ruleMin * 1) {
                        this.$message.warning('最大值必须大于最小值')
                        this.$set(this.form, field, '')
                    }
                }
                if (value && field == 'ruleMin') {
                    if (ruleMax && value && value >= ruleMax * 1) {
                        this.$message.warning('最小值必须小于最大值')
                        this.$set(this.form, field, '')
                    }
                }
            },
            // 附件大小
            attachmentSize() {
                let ruleMax = this.form.ruleMax
                let format = this.form.ruleMaxFormat
                if (!/^\+?[1-9][0-9]*$/.test(ruleMax) || ruleMax < 1) {
                    this.$set(this.form, 'ruleMax', '')
                    this.$message.warning('请输入正确的附件大小')
                } else if (format == "GB" && ruleMax > 2) {
                    this.$set(this.form, 'ruleMax', '')
                    this.$message.warning('最大不可超过2GB')
                } else if (format == "MB" && ruleMax > 2048) {
                    this.$set(this.form, 'ruleMax', '')
                    this.$message.warning('最大不可超过2048MB')
                } else if (format == "KB" && ruleMax > 2097512) {
                    this.$set(this.form, 'ruleMax', '')
                    this.$message.warning('最大不可超过2097512KB')
                }
            },
            // 文件数量
            fileNum() {
                let ruleNumberMax = this.form.ruleNumberMax
                if (!/^\+?[1-9][0-9]*$/.test(ruleNumberMax) || ruleNumberMax > 500 || ruleNumberMax < 1) {
                    this.$set(this.form, 'ruleNumberMax', '')
                    this.$message.warning('请输入正确的文件数量（1-500）')
                }
            },
            // 最大数值
            changeRuleMax(val) {
                if (val && this.form.ruleDefaultValue) {
                    this.$set(this.form, 'ruleDefaultValue', this.form.ruleDefaultValue.substring(0, val))
                }
            },
            // 数据规则
            changeRuleMode(val) {
                if (val != 1) {
                    this.form.ruleDetailList = []
                    this.form.ruleStartNumber = ''
                    this.form.ruleAssociationBasicId = ''
                    this.form.ruleStep = ''
                }
            },
            // 日期区间限制
            changeRuleDateType(val) {
                if (val != 2) {
                    this.startDate = []
                }
            },
            // 数字默认值
            changeRuleDefaultValue() {
                let {ruleMin, ruleMax, ruleDefaultValue, ruleDecimal} = this.form
                if (ruleDefaultValue && !/^[-+]{0,1}(\d+)$|^[-+]{0,1}(\d+\.\d+)$/.test(ruleDefaultValue)) {
                    this.$set(this.form, 'ruleDefaultValue', '')
                    this.$message.warning('请输入正确的默认值')
                } else if (ruleMin && parseInt(ruleDefaultValue) < parseInt(ruleMin)) {
                    this.$set(this.form, 'ruleDefaultValue', '')
                    this.$message.warning('默认值不能小于最小值')
                } else if (ruleMax && parseInt(ruleDefaultValue) > parseInt(ruleMax)) {
                    this.$set(this.form, 'ruleDefaultValue', '')
                    this.$message.warning('默认值不能大于最大值')
                } else {
                    if (!ruleDefaultValue) {
                        return
                    }
                    let num = (this.form.ruleDefaultValue * 1).toFixed(parseInt(ruleDecimal))
                    this.$set(this.form, 'ruleDefaultValue', num)
                }
            },
            // 选择关联元数据
            changeRuleAssociation(val) {
                let item = this.ruleAssociationBasicIdOpt.filter(v => v.id == val)[0]
                if (!item) {
                    this.form.ruleAssociationValue = ''
                    return
                }
                // 13附件、14图片、15视频、17音频
                if (item.basicAssemblyId == '13') {
                    this.ruleAssociationValueOpt = this.$dictUtils.getDictList('ruleAssociationValue').filter(v => {
                        return v.value != '时长' && v.value != '像素'
                    })
                } else if (item.basicAssemblyId == '14') {
                    this.ruleAssociationValueOpt = this.$dictUtils.getDictList('ruleAssociationValue').filter(v => {
                        return v.value != '时长' && v.value != '页数'
                    })
                } else if (item.basicAssemblyId == '15') {
                    this.ruleAssociationValueOpt = this.$dictUtils.getDictList('ruleAssociationValue').filter(v => {
                        return v.value != '页数'
                    })
                } else if (item.basicAssemblyId == '17') {
                    this.ruleAssociationValueOpt = this.$dictUtils.getDictList('ruleAssociationValue').filter(v => {
                        return v.value != '页数' && v.value != '像素'
                    })
                } else {
                    this.ruleAssociationValueOpt = []
                }
            },
            // 选择参数值
            selRuleAssociationValue() {
                if (!this.form.ruleAssociationBasicId) {
                    this.$message.warning('请先选择关联元数据')
                }
            },
            // 数据关联-业务配置关联的模板  type：1数据回显
            getTemplate(type) {
                this.loading = true
                if(!this.form.associationBasicDataId) {
                    return
                }
                this.$axios(this.api.metadata.metadatatableconfigGetById + '?configId=' + this.form.associationBasicDataId + '&metadataFonctionsModelId=', [], 'post').then(data => {
                    if (data.status) {
                        if (type != 1) {
                            this.form.metadataBasicDataRuleLoadsetting = []
                        }
                        data.data.basicDataIdList.map(item => {
                            let list = this.form.metadataBasicDataRuleLoadsetting.filter(v => v.basicDataId == item.basicDataId)
                            if (!list.length) {
                                this.form.metadataBasicDataRuleLoadsetting.push({
                                    basicDataId: item.basicDataId,
                                    basicDataName: item.basicDataName,
                                })
                            } else {
                                list.map(v => {
                                    if(v.basicDataId == item.basicDataId) {
                                        this.$set(v, 'basicDataName', item.basicDataName)
                                    }
                                })
                            }
                        })
                        this.$nextTick(() => {
                            this.form.metadataBasicDataRuleLoadsetting.map(item => {
                                this.getBasicSys(item, type)
                            })
                        })
                    }
                })
            },
            // 查询元数据模板字段  type：1数据回显
            getBasicSys(item, type) {
                this.$axios(this.api.metadata.queryUnionBasicDataDetailsByBasicDataIds, [item.basicDataId], 'post').then(data => {
                    if (data.status) {
                        this.$set(item, 'children', data.data)
                        if (!item.hasOwnProperty('metadataBasicDataAssociationDetailList')) {
                            this.$set(item, 'metadataBasicDataAssociationDetailList', [])
                        }
                        if (type == 1) {
                            item.metadataBasicDataAssociationDetailList.map(itemC => {
                                this.archivesChange(item, itemC, 1)
                            })
                        }
                    }
                    this.loading = false
                })
            },
            // 获取条件字典
            getMethodCode(item) {
                let condition = this.$dictUtils.getDictList('condition')
                let opt = condition.filter(v => v.value != '>=' && v.value != '<=')
                if (item.basicAssemblyId == '8' || item.basicAssemblyId == '9' || item.basicAssemblyId == '12') {
                    opt = condition.filter(v => v.value != '%' && v.value != '!%')
                }
                return opt
            },
            // 选择元数据字段
            archivesChange(item, itemC, type) {
                let val = item.children.filter(v => v.id == itemC.basicDataDetailId)[0]
                if(!val) {
                    return
                }
                this.$set(itemC, 'basicAssemblyId', val.basicAssemblyId)
                this.$set(itemC, 'basicRangeList', val.basicRangeList)
                this.$set(itemC, 'metadataBasicDataRuleVo', val.metadataBasicDataRuleVo)
                if (type) {
                    if (Array.isArray(itemC.conditionValue)) {
                        if (itemC.basicAssemblyId != 6 && itemC.basicAssemblyId != 7) {
                            this.$set(itemC, 'conditionValue', itemC.conditionValue[0])
                        }
                    }
                } else {
                    this.$set(itemC, 'conditionValue', null)
                }
            },
            // 选择条件
            conditionChange(itemC) {
                this.$set(itemC, 'conditionValue', null)
            },
            // 添加筛选条件
            addCondition(item) {
                item.metadataBasicDataAssociationDetailList.push({
                    basicDataId: item.basicDataId,
                    conditionApproach: 'and',
                    basicDataDetailId: "",
                    basicCondition: "",
                    conditionValue: '',
                })
            },
            // 删除筛选条件
            delCondition(item, index) {
                this.$confirm(`确定删除所选项吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    item.metadataBasicDataAssociationDetailList.splice(index, 1);
                })
            },
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let p = JSON.parse(JSON.stringify(this.form))
                        p.ruleAssociationList = []
                        p.ruleDateStart = this.startDate && this.startDate.length ? this.startDate[0] : ''
                        p.ruleDateEnd = this.startDate && this.startDate.length ? this.startDate[1] : ''
                        p.ruleDetailList.map((item, index) => {
                            if (item.basicDataDetailId == '0' || item.basicDataDetailId == '1') {
                                item.basicDataDetailId = ''
                            }
                            item.sort = index + 1
                        })
                        p.metadataBasicDataRuleLoadsetting.map(item => {
                            delete item.children
                            item.metadataBasicDataAssociationDetailList.map(v => {
                                if (!v.conditionValue) {
                                    v.conditionValue = []
                                } else if (v.conditionValue && !Array.isArray(v.conditionValue)) {
                                    v.conditionValue = [v.conditionValue]
                                }
                            })
                        })
                        this.$axios(this.api.metadata.metadatabasicdataruleSave, p, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('保存成功')
                                this.visible = false
                                this.$emit('refreshDataList')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    .fieldBox {
        border: 1px solid #eeeeee;
        border-radius: 10px;
        margin: 10px 0 0;
        padding: 5px 10px;
        font-size: 12px;
        line-height: 22px;
    }

    ::v-deep .el-input-number--small .el-input-number__decrease, ::v-deep .el-input-number--small .el-input-number__increase {
        display: none !important;
    }

    ::v-deep .el-input-number .el-input__inner {
        text-align: left !important;
        padding: 0 15px !important;
    }

    .conditionBox .el-form-item {
        display: inline-block !important;
        width: 26% !important;
    }

    .conditionBox .conditionApproach {
        width: 10% !important;
    }

</style>
